import React from "react";
import TextTruncate from "./TextTruncate";
import { highlightedString } from "../../helperFunctions/parseSearch";

const DEFAULT_NUMBER_OF_LINES = 3;

const Description = (props) => {
  const { query, description, lines, fullSize } = props;
  const html =
    query && description
      ? highlightedString(
          description.replace(/(<([^>]+)>)/gi, "").substring(0, 500),
          query
        )
      : description;
  return !fullSize ? (
    <TextTruncate clamp={lines ? lines : DEFAULT_NUMBER_OF_LINES}>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </TextTruncate>
  ) : (
    <div dangerouslySetInnerHTML={{ __html: html }} />
  );
};

export default Description;
